export const zh = {
  'ad.label': '广告',
  'ad.sponsored_by': '由 {advertiser} 赞助',
  'ad.visit': '访问',
  'cookies.preferences': 'Cookie 偏好',
  'cookies.title': '你的隐私，由你掌控',
  'cookies.description': '我们使用必要的存储以确保 Albambam 正常运行。只有在获得你的许可后，我们才会启用分析或营销功能。你可以随时撤回许可。请查阅',
  'cookies.privacy_link': '隐私政策',
  'cookies.close': '关闭偏好设置',
  'cookies.necessary': '必要',
  'cookies.necessary_desc': '会话、安全、语言和基本偏好。',
  'cookies.analytics': '分析',
  'cookies.analytics_desc': '匿名使用统计，用于改进服务。',
  'cookies.marketing': '营销',
  'cookies.marketing_desc': '广告个性化和广告投放效果统计。',
  'cookies.configure': '设置',
  'cookies.reject': '拒绝可选项',
  'cookies.save': '保存选择',
  'cookies.accept': '全部接受',
  'lang.selector_label': '语言',
  'lang.changed': '语言已更改',
  'nav.home': '首页',
  'nav.categories': '分类',
  'nav.shorts': '短视频',
  'nav.friends': '好友',
  'nav.upload': '上传',
  'nav.profile': '个人资料',
  'nav.login': '登录',
  'common.signed_in': '已登录',
  'common.error': '错误',
  'topbar.search_placeholder': '搜索视频、创作者...',
  'legal.terms': '条款',
  'legal.privacy': '隐私',
  'nav.admin': '管理',
  'nav.logout': '退出登录',
  'admin.tab.payments': '收款',
  'admin.payments.title': '收款',
  'cats.title': '分类',
  'cats.all': '全部',
  'cats.adult_title': '18+ 分类',
  'cats.empty': '此分类暂无视频。',
  'friends.block_confirm': '拉黑该好友？你们将无法再聊天或以好友身份查看对方。',
  'friends.accepted': '你们现在是好友了！',
  'friends.title': '好友',
  'friends.subtitle': '只有互相关注的人才能成为好友并进行私聊。',
  'friends.unread_count_label': '{n} 条未读消息',
  'friends.blocked_users_title': '已拉黑的用户',
  'friends.unblock_user': '取消拉黑',
  'friends.requests_title': '聊天请求',
  'friends.request_badge': '请求',
  'friends.request_accept': '接受',
  'friends.request_ignore': '忽略',
  'friends.empty_title': '你还没有好友',
  'friends.empty_subtitle': '关注某人并让对方回关，即可解锁私聊。',
  'friends.attach_image': '照片',
  'friends.shared_video_label': '分享了一个视频',
  'friends.select_conversation': '选择一位好友开始聊天',
  'friends.block_user': '拉黑',
  'friends.no_messages_yet': '还没有消息。打个招呼吧！',
  'friends.message_placeholder': '输入消息...',
  'section.trending': '热门',
  'section.shorts': '短视频',
  'section.for_you': '为你推荐',
  'home.hero.badge': '欢迎来到 Albambam',
  'home.hero.title_1': '短视频。',
  'home.hero.title_2': '真实的创作者。',
  'home.hero.subtitle': '观看、分享并赚取收益。上传你的视频，在每个分类中发现新人才。',
  'home.hero.cta_shorts': '观看短视频',
  'home.hero.cta_trending': '热门',
  'home.shorts.see_all': '查看全部',
  'home.empty.title': '暂无视频',
  'home.empty.subtitle': '创作者上传内容后，将显示在这里。',
  'live.send_diamonds': '赠送钻石',
  'live.buy': '购买',
  'live.chat': '聊天',
  'live.type_message': '输入消息...',
  'live.send': '发送',
  'auth.success_google': '已通过 Google 登录',
  'auth.fail_google': 'Google 会话无效',
  'auth.success_login': '已登录',
  'auth.success_register': '账号已创建',
  'auth.login_tab': '登录',
  'auth.register_tab': '注册账号',
  'auth.email': '电子邮箱',
  'auth.password': '密码',
  'auth.submit_login_loading': '登录中...',
  'auth.submit_login': '登录',
  'auth.name': '姓名',
  'auth.submit_register_loading': '创建中...',
  'auth.submit_register': '注册账号',
  'auth.or': '或',
  'legal.privacy_title': '隐私政策',
  'search.title': '"{q}" 的搜索结果',
  'search.count': '{n} 个视频',
  'search.empty': '没有结果。',
  'series.load_error': '无法加载该系列',
  'series.unlocked': '系列已解锁',
  'series.purchase_error': '无法开始购买',
  'series.restricted': '访问受限',
  'series.configure_access': '设置访问权限',
  'series.language_all': '所有语言',
  'series.episode_count': '{n} 集',
  'series.buy': '购买系列',
  'series.filter_language': '按语言筛选',
  'series.no_episodes': '还没有已发布的剧集。',
  'series.episode_number': '第 {n} 集',
  'legal.terms_title': '条款与条件',
  'lang.ca': '加泰罗尼亚语',
  'lang.en': '英语',
  'lang.es': '西班牙语',
  'lang.fr': '法语',
  'lang.de': '德语',
  'lang.it': '意大利语',
  'lang.eu': '巴斯克语',
  'lang.gl': '加利西亚语',
  'lang.zh': '中文',
  'lang.other': '其他',
  'lang.vi': '越南语',
  'lang.ja': '日语',
  'lang.ko': '韩语',
  'lang.ru': '俄语',
  'lang.ro': '罗马尼亚语',
  'lang.ar': '阿拉伯语',
  'lang.tr': '土耳其语',
  'lang.pl': '波兰语',
  'lang.ms': '马来语',
  'lang.ta': '泰米尔语',
  'upload.series_title_error': '请输入系列标题',
  'upload.series_adult_category_error': '请为该系列选择 18+ 分类',
  'upload.series_created': '系列已创建',
  'upload.series_create_error': '无法创建系列',
  'upload.err_file': '请选择有效的视频文件',
  'upload.err_title': '请填写标题',
  'upload.series_select_error': '请选择或创建一个系列',
  'upload.trailer_target_error': '请选择预告片对应的视频或系列',
  'upload.price_error': '请输入至少 0.50 欧元的有效价格。',
  'upload.adult_category_error': '请选择成人分类',
  'upload.success': '视频上传成功',
  'upload.title_h': '上传视频',
  'upload.kind': '发布类型',
  'upload.kind_video': '独立视频',
  'upload.kind_episode': '系列剧集',
  'upload.kind_trailer': '短视频中的公开预告片',
  'upload.series': '系列',
  'upload.series_select': '选择一个系列',
  'upload.episode': '剧集',
  'upload.series_new_title': '新系列标题',
  'upload.series_create': '创建系列',
  'upload.series_adult': '18+ 系列',
  'upload.series_premium': '高级系列',
  'upload.series_adult_category': '系列的 18+ 分类',
  'upload.series_price': '每集及打包价格（欧元）',
  'upload.trailer_for': '预告片介绍',
  'upload.trailer_select': '选择视频或系列',
  'upload.video_prefix': '视频',
  'upload.file_label': '视频文件（MP4，最大 1GB）',
  'upload.file_pick': '点击选择视频',
  'upload.thumb_label': '缩略图（可选）',
  'upload.video_title': '标题',
  'upload.description': '描述',
  'upload.category': '分类',
  'upload.is_short': '这是短视频（竖屏）',
  'upload.paid_video': '付费视频',
  'upload.adult_content': '18+ 内容',
  'upload.video_language': '视频语言',
  'upload.individual_price': '观看此视频的价格（欧元）',
  'upload.paid_video_help': '观众购买后仅可永久观看此视频。最低价格为 0.50 欧元。',
  'upload.adult_category': '成人分类',
  'upload.uploading': '上传中 {n}%',
  'upload.submit': '上传视频',
  'user.followers': '粉丝',
  'user.following': '关注',
  'user.follow': '关注',
  'user.chat_open': '聊天',
  'user.request_sent': '请求已发送',
  'user.send_message': '发送消息',
  'user.followers_title': '粉丝',
  'user.following_title': '关注中',
  'user.unfollow': '取消关注',
  'user.request_title': '聊天请求',
  'user.request_subtitle': '你只能发送一条消息。如果对方接受你的请求，你们将成为好友并可以聊天。',
  'user.request_placeholder': '输入你的消息...',
  'user.request_send': '发送请求',
  'shorts.login_for_like': '登录后点赞',
  'watch.share_copied': '链接已复制',
  'watch.delete_confirm': '删除这条评论？',
  'ad.skip_in': '{n}秒后可跳过',
  'ad.skip': '跳过广告',
  'watch.share': '分享',
  'friends.share_video': '分享视频',
  'friends.send': '发送',
  'watch.comments': '评论',
  'watch.write_comment': '写下评论...',
  'watch.publish': '发布',
  'watch.login_to_comment': '需要登录才能评论。',
  'watch.login_btn': '登录后评论',
  'watch.no_comments': '暂无评论。',
  'watch.related': '相关视频',
  'nav.trending': '热门',
  'friends.follow_option_only_follow': '关注',
  'friends.follow_option_friends': '好友',
  'watch.like': '点赞',
  'watch.views_short': '{n} 次观看',
  'shorts.empty.title': '暂无短视频',
  'shorts.empty.subtitle': '上传一个短视频来开启这个版块。',
  'shorts.share': '分享',
  'auth.continue_google': '使用 Google 继续',
  'upload.is_premium': '高级',
  'upload.price': '价格（€）',
  'upload.err_select': '请选择视频',
  'profile.upload_btn': '上传视频',
  'profile.tab_videos': '我的视频（{n}）',
  'profile.tab_history': '历史记录',
  'profile.tab_recos': '推荐',
  'profile.no_videos': '你还没有上传任何视频。',
  'profile.no_history': '你还没有观看任何视频。',
  'profile.no_recos': '观看一些视频即可获得推荐。',
  'profile.likes': '点赞',
  'profile.views': '次观看',
  'wallet.title': '钱包',
  'wallet.rate_label': '费率',
  'wallet.min_label': '最低提现额',
  'wallet.amount_label': '提现金额',
  'wallet.withdraw_btn': '申请提现',
  'wallet.history_title': '申请历史',
  'wallet.success': '申请已创建',
  'wallet.bad_amount': '金额无效',
  'wallet.per_view': '{rate} {cur}/次观看',
  'admin.title': '管理',
  'admin.stats.users': '用户',
  'admin.stats.videos': '视频',
  'admin.stats.shorts': '短视频',
  'admin.stats.views': '观看次数',
  'admin.tab.videos': '视频',
  'admin.tab.ads': '广告',
  'admin.tab.users': '用户',
  'admin.tab.withdrawals': '提现',
  'admin.tab.config': '设置',
  'admin.tab.translations': '语言',
  'tbl.title': '标题',
  'tbl.creator': '创作者',
  'tbl.category': '分类',
  'tbl.type': '类型',
  'tbl.views': '观看',
  'tbl.likes': '点赞',
  'tbl.status': '状态',
  'tbl.actions': '操作',
  'tbl.placement': '位置',
  'tbl.advertiser': '广告主',
  'tbl.impressions': '展示',
  'tbl.clicks': '点击',
  'tbl.active': '启用',
  'tbl.name': '姓名',
  'tbl.email': '邮箱',
  'tbl.role': '角色',
  'tbl.wallet': '钱包',
  'tbl.amount': '金额',
  'tbl.date': '日期',
  'tbl.user': '用户',
  'video.video': '视频',
  'video.short': '短视频',
  'action.show': '发布',
  'action.hide': '隐藏',
  'action.delete_confirm_video': '删除视频？',
  'ad.create_h': '创建广告',
  'ad.title_label': '标题',
  'ad.image_label': '图片 URL',
  'ad.target_label': '目标 URL',
  'ad.advertiser_label': '广告主',
  'ad.placement_label': '投放位置',
  'ad.placement.banner': '横幅（网站）',
  'ad.placement.preroll': '前贴片（视频前）',
  'ad.placement.overlay': '叠加层（视频内）',
  'ad.active': '启用',
  'ad.create_btn': '创建',
  'ad.success_create': '广告已创建',
  'ad.delete_confirm': '删除广告？',
  'users.make_admin': '设为管理员',
  'users.remove_admin': '取消管理员',
  'wd.approve': '批准',
  'wd.reject': '拒绝',
  'wd.mark_paid': '标记已付款',
  'wd.empty': '暂无申请',
  'cfg.title': '付款设置',
  'cfg.rate_label': '每次观看报酬（{cur}）',
  'cfg.min_label': '最低提现额（{cur}）',
  'cfg.currency': '货币',
  'cfg.save': '保存',
  'cfg.saved': '设置已保存',
  'trans.title': '语言与翻译',
  'trans.intro': '上传包含任意语言代码翻译的 JSON 文件（例如 ja、pt、zh）。文件必须包含键 → 文本的扁平映射。',
  'trans.code_label': '语言代码（例如 ja、pt-BR、zh）',
  'trans.name_label': '显示名称（以该语言）',
  'trans.file_label': '翻译 JSON 文件',
  'trans.upload': '上传',
  'trans.uploaded': '翻译已保存',
  'trans.delete': '删除',
  'trans.delete_confirm': '删除此语言？',
  'trans.builtin': '内置',
  'trans.custom': '自定义',
  'trans.empty_custom': '暂无自定义语言。',
  'common.cancel': '取消',
  'common.loading': '加载中...',
  'common.too_fast': '操作太快，请稍等',
  'time.few_seconds': '几秒钟前',
  'time.min': '{n} 分钟前',
  'time.h': '{n} 小时前',
  'time.d': '{n} 天前',
  'time.w': '{n} 周前',
  'time.mo': '{n} 个月前',
  'time.y': '{n} 年前',
  'brand.tagline': '短视频。真实的创作者。',
  'live.section': '直播',
  'live.start': '开始直播',
  'live.end': '结束直播',
  'live.join': '进入直播',
  'live.chat_placeholder': '输入消息...',
  'live.diamond': '钻石',
  'live.buy_access': '购买观看权限',
  'live.save_recording': '保存录像',
};
